import React from 'react'

const LINK_TEST_ID_BY_TYPE = {
  url: 'chat-link-url-id',
  email: 'chat-link-email-id',
  phone: 'chat-link-phone-id'
} as const

export const makePhonesAndLinksClickable = (
  text: string,
  onClick: (url: string) => void,
  className?: string
) => {
  const phonePattern = /(\+?[78](?:[\s()\-]*\d{3}){2}(?:[\s()\-]*\d{2}){2})/g
  const urlPattern =
    /(http|https):\/\/([\w-]+(?:\.[\w-]+)+)([\w#%&+,./:=?@^~-]*[\w#%&+/=?@^~-])/g
  const emailPattern = /([\w.-]+@[\w.-]+\.[\w-]+)/g

  // eslint-disable-next-line security/detect-non-literal-regexp
  const combinedPattern = new RegExp(
    `${phonePattern.source}|${urlPattern.source}|${emailPattern.source}`,
    'g'
  )

  const parts = []
  let lastIndex = 0

  text.replaceAll(combinedPattern, (match, ...args) => {
    const offset = args.at(-2) as number
    if (lastIndex < offset) {
      parts.push(text.slice(lastIndex, offset))
    }

    const linkObj: {
      href: string
      displayText: string
      type: 'phone' | 'email' | 'url'
    } = {
      href: '',
      displayText: match,
      type: 'phone'
    }

    if (phonePattern.test(match)) {
      linkObj.type = 'phone'
      linkObj.href = `tel:${match}`
      phonePattern.lastIndex = 0
    } else if (emailPattern.test(match)) {
      linkObj.type = 'email'
      linkObj.href = `mailto:${match}`
      emailPattern.lastIndex = 0
    } else {
      linkObj.type = 'url'
      linkObj.href = match
      linkObj.displayText = 'ссылка'
    }

    parts.push(
      <a
        key={offset}
        href={linkObj.href}
        className={className}
        data-testid={LINK_TEST_ID_BY_TYPE[linkObj.type]}
        onClick={
          linkObj.type === 'url'
            ? event => {
                event.preventDefault()
                onClick(linkObj.href)
              }
            : undefined
        }
      >
        {linkObj.displayText}
      </a>
    )

    lastIndex = offset + match.length
    return match
  })

  if (lastIndex < text.length) {
    parts.push(text.slice(lastIndex))
  }

  return parts
}
